import { Globals } from '../../modules/Globals';
import axios from 'axios';
import { IUser } from '../../interfaces/IUser';
import { IMember } from '../../interfaces/IMember';
import { ITempImage } from '../../interfaces/ITempImage';
import { IAddress } from '../../interfaces/IAddress';
import ILocationData from '../../interfaces/ILocationData';

const apiUrl = Globals.apiPath + '/users';

export default class UsersService {
  constructor() {}

  async getAll(): Promise<IUser[]> {
    let res = await axios.get<IUser[]>(apiUrl);
    return res.data;
  }

  async getById(id: number): Promise<IUser> {
    let res = await axios.get<IUser>(`${apiUrl}/${id}`);
    return res.data;
  }

  async getByEmail(email: string): Promise<IUser> {
    let res = await axios.get<IUser>(
      `${apiUrl}/byemail?q=${encodeURIComponent(email)}`
    );
    return res.data;
  }

  async create(user: {
    name: string;
    email: string;
    password: string;
    partnerToken?: string;
  }): Promise<IUser> {
    let res = await axios.post<IUser>(`${apiUrl}/signup`, user);
    return res.data;
  }

  async update(user: IUser): Promise<IUser> {
    let res = await axios.put<IUser>(`${apiUrl}/${user.id}`, user);
    return res.data;
  }

  async delete(user: IUser): Promise<IUser> {
    let res = await axios.put<IUser>(`${apiUrl}/${user.id}`);
    return res.data;
  }

  async getRoles(userId: number): Promise<IMember[]> {
    let res = await axios.get<IMember[]>(`${apiUrl}/${userId}/roles`);
    return res.data;
  }

  async getLocation() {
    let res = await axios.get<ILocationData>(`${apiUrl}/l`);
    return res.data;
  }

  async getAddresses(userId: number) {
    let res = await axios.get<IAddress[]>(`${apiUrl}/${userId}/addresses`);
    return res.data;
  }

  async addAddress(userId: number, address: IAddress) {
    let res = await axios.post<IAddress>(
      `${apiUrl}/${userId}/addresses`,
      address
    );
    return res.data;
  }

  async updateAddress(userId: number, address: IAddress) {
    let res = await axios.put<IAddress>(
      `${apiUrl}/${userId}/addresses/${address.id}`,
      address
    );
    return res.data;
  }

  async deleteAddress(userId: number, address: IAddress) {
    let res = await axios.delete<IAddress>(
      `${apiUrl}/${userId}/addresses/${address.id}`
    );
    return res.data;
  }
}
